(function () {
  const observedRoots = new WeakSet();

  function applyContactFormA11y(shadowRoot) {
    const formDialog = shadowRoot.querySelector('section[role="dialog"]');
    if (formDialog && !formDialog.getAttribute('aria-label')?.trim()) {
      formDialog.setAttribute('aria-label', 'Contact form');
    }

    const subjectToggle = shadowRoot.querySelector('form button[class^="_selectToggle"]');
    if (subjectToggle && !subjectToggle.getAttribute('aria-label')?.trim()) {
      subjectToggle.setAttribute('aria-label', 'Subject');
    }

    const commentField = shadowRoot.querySelector('form textarea[name="custom#comment"]');
    if (commentField && !commentField.getAttribute('aria-label')?.trim()) {
      commentField.setAttribute('aria-label', 'Comment');
    }
  }

  function applyContactFormStyles() {
    const host = document.querySelector('shopify-forms-embed');
    const shadowRoot = host?.shadowRoot;

    if (!host || !shadowRoot) return;

    if (shadowRoot.querySelector('style[data-m-contact-form]')) return;

    const style = document.createElement('style');
    style.dataset.mContactForm = '';
    style.textContent = `
      :host section[class^="_formContainer"] {
        --inline-container-max-width: 818px;
        --container-max-w: 818px;

        --forms-base-font-size: 1rem;
        --forms-heading-font-size: var(--font-size-h3);
        --heading-font-size: var(--font-size-h3);

        --forms-body-font: normal var(--font-weight--normal) var(--forms-base-font-size) var(--font-body--family);
        --forms-heading-font: normal var(--font-weight--normal) var(--forms-heading-font-size) var(--font-heading--family);

        --form-placeholder-color: var(--body-text-color);

        --form-field-border: 0 0 0 1px var(--border-color-light);
        --form-field-border-focused: 0 0 0 1px var(--border-color);

        --form-field-border-radius: 0px;
        --button-border-radius: 0px;

        --forms-padding-top: 10px;
        --forms-padding-bottom: 20px;
      }
      section > section[class^="_formContainer"] {
        margin-inline: auto;
      }
      section[class^="_formContainer"] form[class^="_formFieldset"] {
        gap: 14px;
      }
      section[class^="_formContainer"] form[class^="_formFieldset"] {
        gap: 14px;
      }
      form input[class^="_formInputField"],
      form button[class^="_selectToggle"],
      form textarea[class^="_textArea"] {
        box-sizing: border-box;
        line-height: 22px;
      }
      form button[class^="_selectToggle"] {
        max-height: 52px;
      }
      form textarea[class^="_textArea"] {
        height: 260px;
      }
      form button[class^="_formSubmitButton"] {
        font-family: var(--button-font-family-primary);
        text-transform: var(--button-text-case-primary);
        border-radius: var(--style-border-radius-buttons-primary);
        font-weight: 400;
        font-size: 1.375rem;
        line-height: 1;
        letter-spacing: var(--letter-spacing--body-loose);
        width: fit-content;
        padding-block: var(--button-padding-block);
        padding-inline: var(--button-padding-inline);
      }
      form button[class^="_formSubmitButton"]:hover {
        --button-background-color: var(--color-primary-button-hover-background);
        filter: none;
      }
      form + div[class^="_formDisclaimer"] {
        padding-top: 2px;
        text-align: left;
        font-size: 0.75rem;
        line-height: 1.5;
        font-weight: var(--font-weight--medium);
      }
      form + div[class^="_formDisclaimer"] a {
        text-decoration: none;
      }
      form + div[class^="_formDisclaimer"] a:hover {
        text-decoration: underline;
      }
      section[class^="_formBannerContainer"] h2[class^="_formBannerHeading"] {
        text-transform: uppercase;
        line-height: var(--line-height--h3);
        margin-bottom: 14px;
      }
      section[class^="_formBannerContainer"] div[class^="_textBody"] {
        line-height: var(--line-height--body-loose);
      }
    `;
    shadowRoot.appendChild(style);
  }

  function observeContactForm(shadowRoot) {
    if (observedRoots.has(shadowRoot)) return;
    observedRoots.add(shadowRoot);

    const observer = new MutationObserver(() => {
      applyContactFormA11y(shadowRoot);
    });

    observer.observe(shadowRoot, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['aria-label'],
    });
  }

  function applyContactFormPatches() {
    const host = document.querySelector('shopify-forms-embed');
    const shadowRoot = host?.shadowRoot;

    if (!host || !shadowRoot) return false;

    applyContactFormStyles();
    applyContactFormA11y(shadowRoot);
    observeContactForm(shadowRoot);

    return true;
  }

  function waitForContactForm() {
    let attempts = 0;
    const maxAttempts = 80;

    const observer = new MutationObserver(() => {
      if (applyContactFormPatches()) {
        stopWaiting();
      }
    });

    const timer = window.setInterval(() => {
      attempts += 1;
      if (applyContactFormPatches() || attempts >= maxAttempts) {
        stopWaiting();
      }
    }, 250);

    function stopWaiting() {
      observer.disconnect();
      window.clearInterval(timer);
    }

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (!applyContactFormPatches()) {
    waitForContactForm();
  }
})();
